import { PresenterSuggestAssetCategoryResponse } from 'common/open-api'
import { useMemo } from 'react'

import { Suggestion } from '../types'

const MAX_SUGGESTIONS = 4

const byConfidenceDesc = (a: { confidence?: number }, b: { confidence?: number }) =>
  (b.confidence ?? 0) - (a.confidence ?? 0)

export const useAISuggestions = (
  responseData: PresenterSuggestAssetCategoryResponse | undefined,
  assetName?: string
): Suggestion[] => {
  return useMemo(() => {
    if (!responseData) return []

    const {
      asset_category_code,
      asset_category_name,
      service_life,
      confidence,
      alternative_matches,
      proposed_new_category,
      reasoning,
    } = responseData

    const mainSuggestion: Suggestion = {
      asset_name: assetName,
      asset_category_code,
      asset_category_name,
      service_life,
      confidence,
      reasoning,
    }

    const proposedFlattened: Suggestion[] = proposed_new_category
      ? [
          {
            asset_category_name: proposed_new_category.asset_category_name,
            service_life: proposed_new_category.service_life,
            nta_link: proposed_new_category.nta_link,
            logic_path: proposed_new_category.logic_path,
            is_proposed_new_category: true,
          },
          ...(proposed_new_category.alternative_matches || []).map(item => ({
            ...item,
            is_proposed_new_category: true,
          })),
        ]
      : []

    const withAssetName = (item: Suggestion) => ({ ...item, asset_name: assetName })
    const byAssetCategoryName = (item: Suggestion) => item.asset_category_name
    const candidates: Suggestion[] = [
      mainSuggestion,
      ...proposedFlattened.map(withAssetName),
      ...(alternative_matches || []).map(withAssetName),
    ]

    return [...candidates].filter(byAssetCategoryName).sort(byConfidenceDesc).slice(0, MAX_SUGGESTIONS)
  }, [responseData, assetName])
}
